import config from 'config';
import { File } from 'types/models/File';

const { filesHostUrl = '' } = config;

const resolveFileUrl = ({ path = '' }: File): string => path.replace('s3://', filesHostUrl);

export default resolveFileUrl;
